import { createContext } from "react";

export const RefMainContainerContext = createContext(null)